import React from 'react';
import classes from "./menu.module.sass";

const TopMenu = ({children}) => {
    return (
        <div className={classes.topMenu}>
            {children}
        </div>
    );
};

export default TopMenu;